export const SEARCH_REGEXP = /[^a-zA-Z0-9.@\-_\s]/
export const SEARCH_ERROR_MESSAGE = 'Invalid search character not allowed. Try again.'
